"use client";
import { type ReactNode, useState } from "react";
import clsx from "clsx";
import { ChevronUp } from "@/components/newIcons/ChevronUp";

type Props = {
  children: ReactNode;
};
export const IntroductionMarkdown = ({ children }: Props) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <div className={showMore ? "" : "line-clamp-4"}>{children}</div>
      <div
        className="text-base flex items-center cursor-pointer underline justify-end"
        onClick={() => setShowMore(!showMore)}
      >
        {showMore ? "Voir moins" : "Lire la suite"}
        <ChevronUp
          className={clsx("ml-[5px]", {
            "rotate-180": !showMore,
          })}
        />
      </div>
    </>
  );
};
